<template>
  <div class="over-summary">
    <div class="over-header">
      <div class="over-score">
        <div><span>Overs: {{over.over}}</span> | <span class="highlight">Score: {{over.match.runs}}/{{over.match.wicket}}</span> | RR: {{over.match.current_run_rate}}</div>
        <div v-if="over.req_runs">Require {{over.req_runs}} runs from {{over.req_runs_balls}} @ RR {{over.req_run_rate}}</div>
      </div>
      <div class="players">
        <table>
          <tr
          v-for="batsman in over.batsman" :key="batsman.key">
            <td class="info">{{batsman.batting.runs}}({{batsman.batting.balls}} b)</td>
            <td
              class="clickable"
              @click="onPlayerSelected(batsman.key)">{{match.players[batsman.key].name}}<span
               class="changing" v-if="over.isOut(batsman.key)">(out)</span></td>
            <td class="small-font">({{batsman.batting.strike_rate}} SR, {{batsman.batting.fours}}x4s, {{batsman.batting.sixes}}x6s)</td>
          </tr>
          <tr
          v-for="bowler in over.bowler" :key="bowler.key">
            <td class="info">{{bowler.bowling.wickets}}/{{bowler.bowling.overs}}</td>
            <td class="clickable" @click="onPlayerSelected(bowler.key)">{{match.players[bowler.key].name}}</td>
            <td class="small-font">({{bowler.bowling.economy}} Ecom, {{bowler.bowling.maiden_overs}} M, {{bowler.bowling.runs}} R, {{bowler.bowling.extras}} E)</td>
          </tr>
        </table>
      </div>
       <div v-if="over && over.bowling_end">
          <div><span class="header-color">Bowling End:</span> {{over.bowling_end}}</div>
        </div>
    </div>
    <div class="balls">
      <div v-if="state.isLoaded()" :class="{'data-loading': !state.isLoaded(), 'data-loaded': state.isLoaded()}">
        <transition-group name="list-animation" tag="div">
          <div
            v-for="ball in balls"
            :key="ball.key"
          >
            <match-commentary-ball
            :ball="ball"
            @ballSelected="onBallSelected"
            ></match-commentary-ball>
          </div>
        </transition-group>
      </div>
      <div v-else-if="state.isError()" class="center">
        Error loading commentary
        <div>{{state.msg}}</div>
      </div>
      <div v-else-if="state.isError()" class="center">loading...</div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import AppEvents from '@/appevents'
import Utils from '@/utils'
import MatchCommentaryBall from '@/components/cricket/MatchCommentaryBall.vue'

export default {
  components: {
    'MatchCommentaryBall': MatchCommentaryBall
  },
  data () {
    return {
      mountedOver: null,
      balls: [],
      requireBallUpdate: false,
      observer: null,
      intersected: false,
      state: DataState.newNotInit()
    }
  },
  props: {
    match: Object,
    over: Object,
    overKey: String,
    isLastOver: Boolean,
  },
  watch: {
    mountedOver (to, from) {
      if (from != null && to != from) {
        console.log('Over Changed', to, from)
      }
    }
  },
  created () {
    this.$globalEvents.$on(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  beforeDestroy () {
    this.$globalEvents.$off(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  mounted () {
    this.mountedOver = this.over.over
    this.requireBallUpdate = this.isLastOver || (this.match.now.last_ball.over == this.over.over)
    this.observer = new IntersectionObserver(entries => {
      if (this.intersected) { return }
      const firstEntry = entries[0]
      if (firstEntry.isIntersecting) {
        this.intersected = true
        this.observer.disconnect()
        this.onElementVisible()
      }
    })

    this.$nextTick(() => {
      if (this.observer) {
        this.observer.observe(this.$el)
      }
    })
  },
  destroyed () {
    this.observer.disconnect()
  },
  methods: {
    onMatchUpdated (match) {
      if(!this.state.isLoaded()) {return}

      if (this.requireBallUpdate || this.balls.length == 0) {
        this.fetchBalls(true)
      }
    },
    fetchBalls (useFresh) {
      if (this.balls.lenght === 0) {
        this.state.changeToLoading()
      }
      // console.log('Fetch Balls', this.overKey, useFresh, this.requireBallUpdate, this.balls.length)
      this.match.fetchBalls(this.overKey, useFresh).then((balls) => {
        const newBalls = balls.reverse()
        Utils.mergeArray(this.balls, newBalls)
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    onElementVisible () {
      if (this.state.isNotInit()) {
        // console.log('Loading', this.overKey)
        this.fetchBalls()
      }
    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
